import { render } from "./ToplistUsersMypage.vue?vue&type=template&id=4491495a"
import script from "./ToplistUsersMypage.vue?vue&type=script&lang=js"
export * from "./ToplistUsersMypage.vue?vue&type=script&lang=js"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__